/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import { Button, ButtonToolbar, ButtonGroup, Row, Col } from 'reactstrap'

import KeywordsAndValues from '../keywords/KeywordsAndValues.js'
import EditKeywordValueModal from '../keywords/EditKeywordValueModal.js'

import {AppContext} from '../../AppContext';

class ObjectKeywords extends React.Component
{
  keywordColumnKey = 'vaultViewTab.objectKeywords.columnWidths';
  valueColumnKey = 'vaultViewTab.keywordsAndValues.columnWidths';

  debouncedSaveColumnWidths = null;
  columnWidths = {};
  groupedByKeyword = []

  assignSelectedKeyword()
  {
    if (undefined === this.state.selectedRow)
    {
      this.context.postNotification('error', 'You need to expand the keyword group  in order to select a keyword.');
      return;
    }

    this.setState({modalIsOpen: true});
  }

  closeKeywordValueModal()
  {
    this.setState({modalIsOpen: false});
  }

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.keywordColumnKey);
    if ('shared' !== this.props.viewType) this.fetchAssignableKeywords();
    this.fetchKeywordsAndValues();
  }

  constructor(props)
  {
    super();

    let columns =
    [
      {id: 'keywordGroup', accessor: 'keywordGroup', Header: 'Keyword Group', show: true},
      {accessor: 'description', show: false},
      {id: 'keyword', accessor: 'keyword', Header: 'Keyword', show: true},
      {accessor: 'userInputHandling', show: false},
      {accessor: 'keywordGroupId', show: false},
      {accessor: 'keywordId', show: false},
      {accessor: 'keywordId', show: false},
      {accessor: 'keywordValueType', show: false},
    ]

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);

    this.state =
    {
      columns: columns,
      assignableKeywords: [],
      selectedRow: undefined,
      keywordsAndValues: [],
      keywordAndValue: undefined,
      expandedRows: undefined
    }

    this.assignSelectedKeyword = this.assignSelectedKeyword.bind(this);
    this.closeKeywordValueModal = this.closeKeywordValueModal.bind(this);
    this.removeKeyword = this.removeKeyword.bind(this);
    this.refreshKeywordsAndValues = this.refreshKeywordsAndValues.bind(this);
    this.setKeywordValue = this.setKeywordValue.bind(this);
    this.keywordValueChanged = this.keywordValueChanged.bind(this);
  }

  async fetchAssignableKeywords()
  {
    let objectTypeIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) objectTypeIds.push(this.props.selectedObjects[x].objectTypeId);
    objectTypeIds = window.returnUniqueElements(objectTypeIds);

    var bodyData = { objectTypeIds: objectTypeIds };

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getAssignableKeywords', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading assignable keywords');
    this.setState({assignableKeywords: result.jsonData.assignableKeywords});
    if (0 === result.jsonData.assignableKeywords.length)
    {
      this.context.postNotification('info', 'There were no assignable keywords found for the group of objects you have selected. Reduce the set of objects and/or check your keyword groups.');
      return;
    }

    let lastKeywordGroupId = undefined;
    for (let x = 0; x < result.jsonData.assignableKeywords.length; x++)
    {
      if (undefined === lastKeywordGroupId || result.jsonData.assignableKeywords[x].keywordGroupId !== lastKeywordGroupId.keywordGroupId)
      {
        lastKeywordGroupId = {keywordGroupId: result.jsonData.assignableKeywords[x].keywordGroupId, expanded: false};
        this.groupedByKeyword[this.groupedByKeyword.length] = lastKeywordGroupId;
      }
    }
  }

  async fetchKeywordsAndValues()
  {
    let objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) objectIds.push(this.props.selectedObjects[x].objectId);

    var bodyData = { objectIds: objectIds };

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getAssignedKeywords', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error fetching assigned keywords and values');
    for (let x = 0; x < this.groupedByKeyword.length; x++)
      this.groupedByKeyword[x].expanded = false;

    for (let i=0; i <  result.jsonData.assignedKeywords.length; i++)
    {
      if ( result.jsonData.assignedKeywords[i].valueId === null)
      {
         result.jsonData.assignedKeywords[i].keywordValue = '(no value)';
      }

      for (let x = 0; x < this.groupedByKeyword.length; x++)
      {
        if (this.groupedByKeyword[x].keywordGroupId ===  result.jsonData.assignedKeywords[i].keywordGroupId)
          this.groupedByKeyword[x].expanded = true;
      }
    }

    let expandedRows = [];
    for (let x = 0; x < this.groupedByKeyword.length; x++)
    {
      if (this.groupedByKeyword[x].expanded) expandedRows[x] = true;
    }

    this.setState({keywordsAndValues: result.jsonData.assignedKeywords, expandedRows: expandedRows});
  }

  keywordValueChanged(keywordValue)
  {
    let keywordAndValue = this.state.keywordAndValue;
    keywordAndValue.keywordValue = keywordValue;
    this.setState({keywordAndValue: keywordAndValue});
  }

  refreshKeywordsAndValues()
  {
    this.props.refreshVaultViewTab();
    this.fetchKeywordsAndValues();
  }

  async removeKeyword(bodyData)
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'removeAssociatedKeywords', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error removing associated keyword');
    this.context.postNotification('info', 'Associated keyword removed.');
    this.fetchKeywordsAndValues();
    this.props.refreshVaultViewTab();
  }

  render()
  {
    let editKeywordValueModal = null;

    let immutableRowFound = false;
    for (let x = 0; x < this.props.selectedObjects.length; x++)
      if ('Y' === this.props.selectedObjects[x].immutableKeywords)
      {
        immutableRowFound = true;
        break;
      }

    let objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) objectIds.push(this.props.selectedObjects[x].objectId);

    if (this.state.modalIsOpen && !immutableRowFound && 
       ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType))
    {
      editKeywordValueModal = (
        <EditKeywordValueModal  
          objectIds={objectIds} closeModal={this.closeKeywordValueModal} modalIsOpen={this.state.modalIsOpen}
          keywordAndValue={this.state.assignableKeywords[this.state.selectedRow]} viewType={this.props.viewType}
          refreshQueryValues={this.props.refreshQueryValues} refreshKeywordsAndValues={this.refreshKeywordsAndValues}
        />
      );
    }

    return(
      <div>
        {editKeywordValueModal}
        <Row style={{paddingTop: "10px"}}>
        { (!immutableRowFound && ('cataloged' === this.props.viewType || 'uncataloged' === this.props.viewType)) && 
          <Col sm="4">
            <ReactTable data={this.state.assignableKeywords} showPagination={false} columns={this.state.columns} minRows={1} className="-highlight" 
              pivotBy={['keywordGroup']} expanded={this.state.expandedRows} onExpandedChange={(expanded) => {this.setState({ expandedRows: expanded});}}
              noDataText="No keywords available"
              getTrProps={(state, rowInfo, column) =>
              {
                if (rowInfo === undefined || undefined === this.state.selectedRow) return { };
                if (rowInfo.index === this.state.selectedRow)
                  return {style: {fontWeight: "bold", color: "#ffffff", backgroundColor: "#0275d8"}} // #0275d8 matches reactstrap, #00abc7 matches uploader theme
                else
                  return {};
              }}
              getTdProps={(state, rowInfo, column, instance) => 
              {
                return {
                  onDoubleClick: this.assignSelectedKeyword,
                  onClick: (e, handleOriginal) => {this.selectionHandler(e, handleOriginal, rowInfo, column, instance);}
                }
              }}
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)}
            />
            <ButtonToolbar>
              <ButtonGroup size="sm" style={{marginLeft: 'auto'}} >
                <Button title="Assign keyword(s)" color="transparent" onClick={this.assignSelectedKeyword}><img src="assets/images/plus.png" alt="Assign keyword(s)" /></Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Col>
        }
          <Col>
            <KeywordsAndValues   
              selectedObjects={this.props.selectedObjects} keywordsAndValues={this.state.keywordsAndValues} tabIndex={this.props.tabIndex}
              keywordValueChanged={this.keywordValueChanged} removeKeyword={this.removeKeyword} valueColumnKey={this.valueColumnKey}
              refreshQueryValues={this.props.refreshQueryValues} refreshKeywordsAndValues={this.refreshKeywordsAndValues}
              viewType={this.props.viewType} immutableRowFound={immutableRowFound}
            />
          </Col>
        </Row>
      </div>
    )
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.keywordColumnKey);    
  }

  async setKeywordValue(event, bodyData)
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setKeywordValue', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error setting keyword value');
    this.context.postNotification('info', 'Keyword value set.');
    this.fetchKeywordsAndValues();
    this.props.refreshVaultViewTab();
    this.props.refreshQueryValues(bodyData.keywordId);
  }

  selectionHandler(event, handleOriginal, rowInfo, column, instance)
  {
    if (rowInfo.aggregated)
    {
      if (handleOriginal) handleOriginal();
      return;
    } 

    this.setState({selectedRow: rowInfo.index});
    window.clearTextSelection();
  }
}

ObjectKeywords.contextType = AppContext;

export default ObjectKeywords
